/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** Step = step challenge, Spend = spend challenge */
export type ChallengeProgressType = 'Spend' | 'Step';

/** NOT_STARTED = Customer is qualified for challenge, STARTED = Customer has opted in, IN_PROGRESS: challenge is in progress, COMPLETED: customer has completed the challenge */
export type ChallengeStatus = 'COMPLETED' | 'IN_PROGRESS' | 'NOT_STARTED' | 'STARTED';

export type ChallengeTheme = 'DEFAULT' | 'FLASH';

export type ChallengeThemeV2 = 'DEFAULT' | 'FLASH' | 'HURDLE' | 'UNLIMITED';

export type OfferDataFragment = {
  readonly __typename: 'Challenge';
  readonly achieved: number;
  readonly celebrationCopy: string;
  readonly descriptiveTitle: string;
  readonly expirationDate: string | null;
  readonly goal: number;
  readonly id: string;
  readonly legalTerms: string;
  readonly percentageCompleted: number;
  readonly permalink: string;
  readonly progressType: Types.ChallengeProgressType;
  readonly progress: number;
  readonly progressCopy: string;
  readonly status: Types.ChallengeStatus;
  readonly title: string;
  readonly theme: Types.ChallengeTheme;
  readonly assetUrl: string | null;
};

export type LoyaltyOffersQueryVariables = Exact<{ [key: string]: never }>;

export type LoyaltyOffersQuery = {
  readonly challenges: ReadonlyArray<{
    readonly __typename: 'Challenge';
    readonly themeV2: Types.ChallengeThemeV2;
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: string | null;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progressType: Types.ChallengeProgressType;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
    readonly theme: Types.ChallengeTheme;
    readonly assetUrl: string | null;
    readonly multipleBehaviorDetails: {
      readonly hurdleBehaviors: ReadonlyArray<{
        readonly goal: number;
        readonly progress: number;
        readonly achieved: number;
        readonly outcome: number;
      }>;
    } | null;
  }>;
};

export type LoyaltyOfferOptInMutationVariables = Exact<{
  challengeId: string;
}>;

export type LoyaltyOfferOptInMutation = {
  readonly challengeOptInV2:
    | {
        readonly __typename: 'Challenge';
        readonly themeV2: Types.ChallengeThemeV2;
        readonly achieved: number;
        readonly celebrationCopy: string;
        readonly descriptiveTitle: string;
        readonly expirationDate: string | null;
        readonly goal: number;
        readonly id: string;
        readonly legalTerms: string;
        readonly percentageCompleted: number;
        readonly permalink: string;
        readonly progressType: Types.ChallengeProgressType;
        readonly progress: number;
        readonly progressCopy: string;
        readonly status: Types.ChallengeStatus;
        readonly title: string;
        readonly theme: Types.ChallengeTheme;
        readonly assetUrl: string | null;
        readonly multipleBehaviorDetails: {
          readonly hurdleBehaviors: ReadonlyArray<{
            readonly goal: number;
            readonly progress: number;
            readonly achieved: number;
            readonly outcome: number;
          }>;
        } | null;
      }
    | { readonly __typename: 'LoyaltyOptInFailed'; readonly errorMessage: string };
};

export const OfferDataFragmentDoc = gql`
  fragment OfferData on Challenge {
    __typename
    achieved
    celebrationCopy
    descriptiveTitle
    expirationDate
    goal
    id
    legalTerms
    percentageCompleted
    permalink
    progressType
    progress
    progressCopy
    status
    title
    theme
    assetUrl
  }
`;
export const LoyaltyOffersDocument = gql`
  query LoyaltyOffers {
    challenges {
      ...OfferData
      themeV2
      multipleBehaviorDetails {
        ... on HurdleBehaviorDetails {
          hurdleBehaviors {
            goal
            progress
            achieved
            outcome
          }
        }
      }
    }
  }
  ${OfferDataFragmentDoc}
`;

export function useLoyaltyOffersQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyOffersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyOffersQuery, LoyaltyOffersQueryVariables>({
    query: LoyaltyOffersDocument,
    ...options,
  });
}
export const LoyaltyOfferOptInDocument = gql`
  mutation loyaltyOfferOptIn($challengeId: String!) {
    challengeOptInV2(challengeId: $challengeId) {
      __typename
      ... on Challenge {
        ...OfferData
        themeV2
        multipleBehaviorDetails {
          ... on HurdleBehaviorDetails {
            hurdleBehaviors {
              goal
              progress
              achieved
              outcome
            }
          }
        }
      }
      ... on LoyaltyOptInFailed {
        errorMessage
        __typename
      }
    }
  }
  ${OfferDataFragmentDoc}
`;

export function useLoyaltyOfferOptInMutation() {
  return Urql.useMutation<LoyaltyOfferOptInMutation, LoyaltyOfferOptInMutationVariables>(
    LoyaltyOfferOptInDocument,
  );
}
